import * as React from "react";
import { connect } from "react-redux";

import { getQuestionConfig } from "@teamprevent/common/questionnaires/questionnaireConfig";

import { OldProgressBarQuestionnaireSectionUnconnected } from "../../questionnaires/components/OldProgressBarQuestionnaireSection";
import { makeMapStateToQuestionnaireSectionProps, mapDispatchToQuestionnaireSectionProps } from "../../questionnaires/mappers";
import { HealthSurveillanceSectionProps } from "../models";
import * as questionIds from "../questions/questionIds";
import { TextQuestion } from "../../questionnaires/components/questions/TextQuestion";
import { MultiButtonQuestion } from "../../questionnaires/components/questions/MultiButtonQuestion";
import { sections } from "../questionnaire";

const HealthSurveillanceManualHandlingMSKQuestionnaireSectionUnconnected: React.FunctionComponent<HealthSurveillanceSectionProps> =
    (props: HealthSurveillanceSectionProps) => {
        return (
            <OldProgressBarQuestionnaireSectionUnconnected
                {...props}
                {...sections.ManualHandlingMSK}
            >
                <h4>Have you ever suffered from an injury or disorder of the:</h4>
                <MultiButtonQuestion
                    readonly={props.readonly}
                    questionConfig={getQuestionConfig(props.questionConfigs, questionIds.HaveYouEverSufferedFromAnInjuryOrDisorderOfTheNeck)}
                />
                <MultiButtonQuestion
                    readonly={props.readonly}
                    questionConfig={getQuestionConfig(props.questionConfigs, questionIds.HaveYouEverSufferedFromAnInjuryOrDisorderOfTheShoulders)}
                />
                <MultiButtonQuestion
                    readonly={props.readonly}
                    questionConfig={getQuestionConfig(props.questionConfigs, questionIds.HaveYouEverSufferedFromAnInjuryOrDisorderOfTheArms)}
                />
                <MultiButtonQuestion
                    readonly={props.readonly}
                    questionConfig={getQuestionConfig(props.questionConfigs, questionIds.HaveYouEverSufferedFromAnInjuryOrDisorderOfTheWristHandsFingers)}
                />
                <MultiButtonQuestion
                    readonly={props.readonly}
                    questionConfig={getQuestionConfig(props.questionConfigs, questionIds.HaveYouEverSufferedFromAnInjuryOrDisorderOfTheUpperSpine)}
                />
                <MultiButtonQuestion
                    readonly={props.readonly}
                    questionConfig={getQuestionConfig(props.questionConfigs, questionIds.HaveYouEverSufferedFromAnInjuryOrDisorderOfTheLowerSpine)}
                />
                <MultiButtonQuestion
                    readonly={props.readonly}
                    questionConfig={getQuestionConfig(props.questionConfigs, questionIds.HaveYouEverSufferedFromAnInjuryOrDisorderOfTheLegsHipsKnees)}
                />
                <MultiButtonQuestion
                    readonly={props.readonly}
                    questionConfig={getQuestionConfig(props.questionConfigs, questionIds.HaveYouEverSufferedFromAnInjuryOrDisorderOfTheAnklesFeet)}
                />
                <TextQuestion
                    readonly={props.readonly}
                    questionConfig={getQuestionConfig(props.questionConfigs, questionIds.MusculoskeltalInjuryOrDisordersDetails)}
                />
                <TextQuestion
                    readonly={props.readonly}
                    questionConfig={getQuestionConfig(props.questionConfigs, questionIds.MusculoskeltalInjuryOrDisordersTreatmentMedicationDetails)}
                />
                <TextQuestion
                    readonly={props.readonly}
                    questionConfig={getQuestionConfig(props.questionConfigs, questionIds.MusculoskeltalInjuryOrDisordersAffectingDailyLivingDetails)}
                />
                <MultiButtonQuestion
                    readonly={props.readonly}
                    questionConfig={getQuestionConfig(props.questionConfigs, questionIds.WasTheInjuryConditionCausedOrMadeWorseByWork)}
                />
                <MultiButtonQuestion
                    readonly={props.readonly}
                    questionConfig={getQuestionConfig(props.questionConfigs, questionIds.DidYouReceiveAnyTreatment)}
                />
                <TextQuestion
                    readonly={props.readonly}
                    questionConfig={getQuestionConfig(props.questionConfigs, questionIds.CausedWorseByWorkAndTreatmentDetails)}
                />
                <MultiButtonQuestion
                    readonly={props.readonly}
                    questionConfig={getQuestionConfig(props.questionConfigs, questionIds.DoesTheInjuryConditionAffectYourAbilityToWork)}
                />
                <TextQuestion
                    readonly={props.readonly}
                    questionConfig={getQuestionConfig(props.questionConfigs, questionIds.DoesTheInjuryConditionAffectYourAbilityToWorkDetails)}
                />
            </OldProgressBarQuestionnaireSectionUnconnected>
        );
    };

export const HealthSurveillanceManualHandlingMSKQuestionnaireSection =
    connect(makeMapStateToQuestionnaireSectionProps(sections.ManualHandlingMSK.id), mapDispatchToQuestionnaireSectionProps)
    (HealthSurveillanceManualHandlingMSKQuestionnaireSectionUnconnected);
